<template>
  <div
    class="flex flex-col gap-2 rounded border bg-primary-100 p-2 select-none"
  >
    <div>
      <div class="flex flex-row items-center">
        <div
          class="flex flex-1 flex-row items-center gap-2 truncate text-lg font-bold"
        >
          <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" size="lg" />
          <span>{{ $h.formatCurrency(payment.amount, currency) }}</span>
        </div>
        <div class="flex shrink-0 gap-x-1">
          <div>
            <p
              v-if="paymentInAwating"
              class="rounded-md bg-orange-200 px-1 py-0.5 text-xs font-semibold text-black"
            >
              {{ $t('attributes.snoozed') }}
            </p>
          </div>
          <template v-if="!notLinkedPayment">
            <!--            <div>-->
            <!--              <BaseButton-->
            <!--                v-if="!paymentInAwating || payment.tier_payant"-->
            <!--                icon="print"-->
            <!--                color="primary"-->
            <!--                size="extra-small"-->
            <!--                @click="printPayment"-->
            <!--              />-->
            <!--            </div>-->
            <div>
              <BaseButton
                icon="pen"
                color="primary"
                size="extra-small"
                @click="isPaymentFormModalOpen = true"
              />
            </div>
            <div>
              <BaseButton
                icon="trash"
                color="danger"
                size="extra-small"
                @click.stop="deletePayment"
              />
            </div>
          </template>
          <template v-else>
            <div>
              <BaseButton
                icon="link"
                icon-type="fas"
                color="primary"
                size="extra-small"
                :title="$t('button.payment.link_payment')"
                @click="$emit('link-payment', payment.id)"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div>
      <ViewData :data="dataView" size="extra-small" />
    </div>
    <PaymentFormModal
      v-model:is-modal-open="isPaymentFormModalOpen"
      :payment-id="payment.id"
      :model="dossier"
      model-type="dossier"
      dossier-contacts="dossier.contact"
      :place-holder-direct-debit="dossier.concernedPerson.full_name"
      :place-holder-issuer="payment.payer?.full_name"
    />
    <ConfirmModal ref="1234">
      <template #default>
        <div class="mt-3 divide-y rounded-lg border">
          <label
            v-for="deleteChoice in deleteChoices"
            class="flex cursor-pointer flex-row gap-3 p-3 capitalize-first"
            :class="{
              'text-red-500': deleteChoice.danger
            }"
          >
            <div class="flex shrink-0 items-center justify-center">
              <input
                v-model="selectedDeleteChoice"
                :value="deleteChoice.value"
                type="radio"
                name="delete_choice"
                class="text-primary focus:ring-0 focus:ring-offset-0 active:ring-0 active:ring-offset-0"
              />
            </div>
            <div class="flex-1">
              <h5 class="font-bold capitalize-first">
                {{ deleteChoice.title }}
              </h5>
              <p
                class="text-xs capitalize-first"
                v-html="deleteChoice.description"
              ></p>
            </div>
          </label>
        </div>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import ViewData from '@c/ViewComponents/ViewData.vue'
import { issuingBankName } from '@ui/modal/payment/issuingBank'
import PaymentFormModal from '@ui/modal/payment/PaymentFormModal.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ConfirmModal from '@c/addf-package/components/modal/ConfirmModal.vue'

export default {
  name: 'PaymentDossierCard',
  components: {
    ConfirmModal,
    ViewData,
    FontAwesomeIcon,
    PaymentFormModal,
    BaseButton
  },
  props: {
    payment: {
      type: Object,
      required: true
    },
    paymentModes: {
      type: Array,
      required: true
    },
    notLinkedPayment: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['delete'],
  data() {
    return {
      isPaymentFormModalOpen: false,
      selectedDeleteChoice: null
    }
  },
  computed: {
    ...mapGetters({
      dossier: 'dossier/getDossier',
      currencySettings: 'metadata/getDefaultCurrencyMetadata',
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    currency() {
      return this.dossier?.funeral_home?.currency_code ?? this.currencySettings
    },
    issuingBank() {
      return issuingBankName(this.payment, this.initialMetadata?.models?.banks)
    },
    dataView() {
      return [
        [
          [
            {
              label: this.$t('attributes.emission_date'),
              value: this.$h.formatDate(this.payment.emission_date, 'LL'),
              gate: true
            },
            {
              label: this.$t('global.third_payment'),
              value:
                this.payment.payer?.full_name ?? this.payment.issuer_name ?? '',
              gate: !!this.payment.tier_payant
            },
            {
              label: this.$t('attributes.issuer_name'),
              value:
                this.payment.payment_mode === 'LEV'
                  ? this.$t('enums.invoicing.paymentMode.LEV')
                  : (this.payment.payer?.full_name ??
                    this.payment.issuer_name ??
                    ''),
              gate: !this.payment.tier_payant
            },
            {
              label: this.$t('attributes.check_issuer_bank'),
              value: this.issuingBank,
              gate: !!this.issuingBank
            },
            {
              label: this.$t('attributes.remarks'),
              value: this.payment.comment,
              gate: !!this.payment.comment
            }
          ]
        ],
        []
      ]
    },
    icon() {
      return (
        this.paymentModes?.find(
          (payment_mode) => payment_mode.id === this.payment.payment_mode
        )?.icon ?? null
      )
    },
    paymentInAwating() {
      if (this.payment.payment_status === 'AWA') {
        return true
      }
      const chequeDeductionRule =
        this.initialMetadata?.settings?.default_cheque_deduction
      if (chequeDeductionRule === 'MCA') {
        if (
          this.payment.payment_mode === 'CHE' &&
          this.payment.check_status !== 'CAS'
        ) {
          return true
        }
      }
      if (chequeDeductionRule === 'CID') {
        if (this.payment.payment_mode === 'CHE') {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const expectingCashingDate = new Date(
            this.payment.expected_cashing_date
          )
          expectingCashingDate.setHours(0, 0, 0, 0)
          if (expectingCashingDate > today) {
            return true
          }
        }
      }
      return false
    },
    deleteChoices() {
      return [
        // {
        //   value: 'cancel_payment',
        //   title: this.$t('global.payment.cancel_payment'),
        //   description: this.$t('global.payment.cancel_payment_desc'),
        //   danger: false
        // },
        {
          value: 'unlink_payment',
          title: this.$t('global.payment.unlink_payment'),
          description: this.$t('global.payment.unlink_dossier_payment_desc'),
          danger: false
        },
        {
          value: 'delete_payment',
          title: this.$t('global.payment.delete_payment'),
          description: this.$t('global.payment.delete_dossier_payment_desc'),
          danger: true
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      processFetchNewPaymentAction: 'invoicing/fetchNewPayment',
      processStoreNewPaymentToDossierAction: 'dossier/storeNewPaymentToDossier',
      processFetchPaymentByIdAction: 'invoicing/fetchPaymentById',
      processUpdatePaymentByIdAction: 'invoicing/updatePaymentById'
    }),
    async deletePayment() {
      let result = await this.$refs['1234'].show({
        title: this.$t('global.payment.delete_payment')
      })
      if (result) {
        this.$emit('delete', this.payment.id, this.selectedDeleteChoice)
      }
    },
    printPayment() {
      this.$router.push({
        name: 'invoice_print_payment_route',
        params: {
          invoicing_id: this.$route.params.invoicing_id,
          payment_id: this.payment.id
        }
      })
    },
    submitForm() {
      if (this.paymentModes?.length > 0 && !this.payment.payment_mode_id) {
        this.payment_mode_error = true
        return
      }
      this.formSubmitting = true
      if (!this.paymentId) {
        this.processStoreNewPaymentToDossierAction({
          dossier_id: this.dossier.id,
          payment: this.payment
        })
          .then((_response) => {
            this.$h.toastSuccess(this.$t('toasts.payment_added_to_dossier'))
            this.localIsModalOpen = false
            this.formSubmitting = false
            this.payment_mode_error = false
          })
          .catch((_reason) => {
            this.formSubmitting = false
            this.$emit('update:is-modal-open', false)
          })
      } else {
        this.processUpdatePaymentByIdAction({
          dossier_id: this.dossier.id,
          payment_id: this.payment.id,
          payment: this.payment
        })
          .then((_response) => {
            this.$h.toastSuccess(this.$t('toasts.payment_updated'))
            this.localIsModalOpen = false
            this.formSubmitting = false
            this.payment_mode_error = false
          })
          .catch((_reason) => {
            this.formSubmitting = false
          })
      }
    }
  }
}
</script>
